import { InitWorkerRequestType, InitWorkerApi } from 'initWorker';
import { client } from '../client';
import { ApiConfiguration } from './api-configuration';
import { Configuration } from './configuration';
import { asApiConfiguration, asConfiguration } from './mapper';

const get = async () => {
  let res: ApiConfiguration;

  try {
    res = (await InitWorkerApi.getData(
      InitWorkerRequestType.TimesheetConifg,
    )) as ApiConfiguration;
  } catch {
    res = await client.get<ApiConfiguration>('/timesheets/configuration');
  }

  return asConfiguration(res);
};

const put = (value: Configuration) =>
  client
    .put<ApiConfiguration, ApiConfiguration>(
      '/timesheets/configuration',
      asApiConfiguration(value),
    )
    .then(asConfiguration);

export const ConfigurationApi = {
  get,
  put,
};
